import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ClipboardList } from "lucide-react";

// Development Inventory = the diagnosis. The plan (Panel 4 · What it points to) lives on the Training tab; this line links to that section's plan.
export function PlanLink({ playerId, sectionKey }) {
  return (
    <Link to={`/player/${playerId}?tab=training#plan-${sectionKey}`} className="flex items-center gap-2 border border-dashed border-[var(--org-accent)]/40 bg-[#141414] px-4 py-2.5 text-[10px] uppercase tracking-[0.3em] font-bold text-[var(--org-accent)] hover:border-[var(--org-accent)] hover:bg-[var(--org-accent)]/5" data-testid={`plan-link-${sectionKey}`}>
      <span className="text-[9px] font-mono">4</span><ClipboardList className="w-3.5 h-3.5" /> Plan <ArrowRight className="w-3 h-3" /> Training tab
      <span className="ml-auto text-[9px] tracking-[0.2em] font-normal text-[#757575] normal-case">Limiting factors · situation games · solutions · film · checkpoints</span>
    </Link>
  );
}
